import React, { useRef, useState, useEffect } from 'react';
import Title from '../../atoms/title/title.js';

const Picker = ({ options, placeholder = "", onOptionSelected, title, description }) => {
    const pickerButtonRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [overlayTop, setOverlayTop] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState(null);
    useEffect(() => {
        setOverlayTop((pickerButtonRef.current?.offsetHeight || 0) + 10);
    }, [pickerButtonRef.current?.offsetHeight]);
    const arrow = (React.createElement("svg", { className: `mbw-picker--carret ${isOpen ? "mbw-picker--carret--open" : "mbw-picker--carret--closed"}`, width: 15, height: 15, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M19 9L12 15L5 9", stroke: "#121212", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
    const onPickerClick = () => {
        setIsOpen(!isOpen);
    };
    const onOptionClick = (option, index) => {
        setSelectedIndex(index);
        setIsOpen(!isOpen);
        if (onOptionSelected) {
            onOptionSelected(option, index);
        }
    };
    const renderTitle = () => {
        if (title) {
            return React.createElement(Title, { fontStyle: "content-default" }, title);
        }
        return null;
    };
    const renderDescription = () => {
        if (description) {
            return React.createElement("div", { className: "mbw-picker--title" },
                React.createElement(Title, { fontStyle: "content-default" }, description));
        }
        return null;
    };
    return (React.createElement("div", null,
        renderTitle(),
        React.createElement("div", { className: "mbw-picker" },
            React.createElement("button", { "data-testid": "mbw-picker-button", ref: pickerButtonRef, onClick: onPickerClick, className: "mbw-picker--button" },
                React.createElement(Title, { fontStyle: "content-default" }, selectedIndex !== null ? options[selectedIndex].title : placeholder),
                arrow),
            isOpen ? (React.createElement("ul", { style: { top: overlayTop || 0 }, className: "mbw-picker--overlay" }, options.map((o, index) => React.createElement("li", { "data-testid": "mbw-picker-option", className: `mbw-picker--option${selectedIndex === index ? " mbw-picker--option--selected" : ""}`, onClick: () => { onOptionClick(o, index); }, key: o.value },
                React.createElement(Title, { fontStyle: "content-default" }, o.title))))) : null),
        renderDescription()));
};
//mbw-picker--option--selected

export { Picker as default };
//# sourceMappingURL=picker.js.map
